import { render, staticRenderFns } from "./ChoseFromVod.vue?vue&type=template&id=628d4ccc&scoped=true&"
import script from "./ChoseFromVod.vue?vue&type=script&lang=js&"
export * from "./ChoseFromVod.vue?vue&type=script&lang=js&"
import style0 from "./ChoseFromVod.vue?vue&type=style&index=0&id=628d4ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d4ccc",
  null
  
)

export default component.exports